import React, {useEffect, useState} from "react";
import Header from "../include/Header"
import Contents from "../include/Contents"
import ContactInfo from "../include/ContactInfo"
import Footer from "../include/Footer"
import WrapTitle from "../include/WrapTitle"
import MovieList from "../info/MovieList"
import SearchBox from "../info/SearchBox"
import AddFavorites from "../info/AddFavorites"
import RemoveFavorites from "../info/RemoveFavorites"
// import Loader from "../include/Loader"
// import { gsap } from "gsap";


const Movie = () =>{
    const [movies, setMovies] = useState([]);
    const [favoriets, setFavorites] = useState([]);
    const [searchValue,setSearchValue] = useState('');

    // const start =() => {
    //     setTimeout(()=>{   
    //         //2초후에 로딩소스 없어짐
    //         document.getElementById("loading").classList.remove("loading-active");
    //         gsap.set(".wrap__title h2 strong", {opacity: 0, y: 100});
    //         gsap.set(".wrap__title h2 em", {opacity: 0, y: 100});
    //         gsap.set("#header", {opacity: 0, top: "-100%"});
    //         gsap.set("#footer", {opacity: 0, bottom: "-100%"});
    //         gsap.set(".script__cont", {opacity: 0});

    //         gsap.to(".wrap__title h2 strong", {duration: 0.4, delay: 1, y: 0, opacity: 1, ease: "power3.out"});
    //         gsap.to(".wrap__title h2 em", {duration: 0.4, delay: 1.4, y: 0, opacity: 1, ease: "power3.out"});
    //         gsap.to("#header", {duration: 0.4, delay: 1.8, top: 0, opacity: 1, ease: "power3.out"});
    //         gsap.to("#footer", {duration: 0.4, delay: 1.8, bottom: 0, opacity: 1, ease: "power3.out"});
    //         gsap.to(".script__cont", {duration: 0.4, delay: 2, opacity: 1, ease: "power3.out"});
           
    //     },1500)

        
    // }
    // start()

    const getMovieRequest = async(searchValue) => {
        const url = `https://www.omdbapi.com/?s=${searchValue}&apikey=7d64c64`;
        
        const response = await fetch(url);
        const responseJson = await response.json();

        if(responseJson.Search){
            setMovies(responseJson.Search);
        }
    };

    useEffect(()=>{
        getMovieRequest(searchValue);
        
    }, [searchValue]);


    //local에 있는 것이 남아 있어서 나타나지롱
    useEffect(() => {
		const movieFavourites = JSON.parse(
			localStorage.getItem('react-movie-app-favourites')
		);

		if (movieFavourites) {
			setFavorites(movieFavourites);
		}
	}, []);


    const saveToLocalStorage = (items) => {
		localStorage.setItem('react-movie-app-favourites', JSON.stringify(items));
	};

    const addFavoriteMovie = (movie) =>{
        const newFavoriteList = [...favoriets, movie]
        setFavorites(newFavoriteList);
        saveToLocalStorage(newFavoriteList);
    };


    const removeFavoriteMovie = (movie) => {
		const newFavoriteList = favoriets.filter(
			(favorite) => favorite.imdbID !== movie.imdbID
		);

		setFavorites(newFavoriteList);
		saveToLocalStorage(newFavoriteList);
	};

    return (
        <div>
            {/* <Loader /> */}
            <Header/>
            <Contents>
                <section id="scriptCont">
                    <div className="container">
                        <WrapTitle text={["Movie","Search"]}/>
                        <div className="script__cont">
                            <SearchBox searchValue={searchValue}  setSearchValue={setSearchValue}/>
                            <div className="script__wrap">
                                <MovieList 
                                    movies={movies} 
                                    handleFavouritesClick={addFavoriteMovie}
                                    favoriteComponent = {AddFavorites}
                                />
                            </div>
                            
                            <div className="script__fav">
                                <h2>Favourite Movie List</h2>
                                <div className="script__wrap">
                                    <MovieList 
                                        movies={favoriets}
                                        handleFavouritesClick={removeFavoriteMovie}
                                        favoriteComponent={RemoveFavorites}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* //scriptCont */}
                <ContactInfo />
                {/* //contactInfo */}
            </Contents>
            <Footer/>
        </div>
    )
}

export default Movie;